import { useCallback, useState } from 'react';

import useToast from '../useToast';

interface SuccessOptions {
  message: string;
}

interface Options {
  restoreSuccess?: boolean;
}

const useFormCallback = (
  { restoreSuccess }: Options | undefined = { restoreSuccess: false },
) => {
  const [isSuccess, setSuccess] = useState<boolean>(false);
  const toast = useToast();

  const onSuccess = useCallback(
    (options?: SuccessOptions, callback?: () => void) => {
      setSuccess(true);
      if (callback) {
        callback();
      }
      if (options) {
        toast.success(options.message);
      }
      if (restoreSuccess) {
        setTimeout(() => {
          setSuccess(false);
        }, 1000);
      }
    },
    [restoreSuccess, toast],
  );

  const onError = useCallback(
    (e: unknown, callback?: () => void) => {
      setTimeout(() => {
        if (e instanceof Error) {
          toast.error(e.message);
        } else {
          toast.error('Oops! Something went wrong');
        }
      }, 100);
      setTimeout(() => {
        if (callback) {
          callback();
        }
      }, 500);
    },
    [toast],
  );

  return { isSuccess, onSuccess, onError };
};

export default useFormCallback;
